import React from 'react';
import PreviousQuestionArrow from './PreviousQuestionArrow';
import QuestionNumberText from './QuestionNumberText';
import styles from './style.module.scss';

interface QuestionNumberProps {
  current: number;
  total: number;
  onPreviousClick: () => void;
  isOptional: boolean;
}

const QuestionNumber: React.FC<QuestionNumberProps> = ({
  current, total, onPreviousClick, isOptional,
}) => {

  const isArrowVisible = current > 1;
  return (
    <div className={styles['survey-question']}>
      <PreviousQuestionArrow onClick={onPreviousClick} isVisible={isArrowVisible} />
      <QuestionNumberText current={current} total={total} isArrowVisible={isArrowVisible} isOptional={isOptional} />
    </div>
  );

};

export default QuestionNumber;
